import { AxiosRequestConfig } from 'axios'
import { ECampaignSubmissionStatus } from 'src/enums/campaign-submission.enum'
import { ICampaignSubmissionModel, TAxiosResponseData } from 'src/interfaces'
import { axiosHiringApi } from './axios'

export class CampaignSubmissionApi {
  static readonly _prefix = '/campaign-submissions'

  static update(
    id: Required<ICampaignSubmissionModel>['id'],
    payload: {
      isHired?: boolean
    },
    config?: AxiosRequestConfig
  ): TAxiosResponseData<void> {
    return axiosHiringApi.put(`${this._prefix}/${id}`, payload, config)
  }

  /**
   * Review an applicant
   * @param id Submission ID
   * @param payload Review data
   * @returns Promise that resolves when the operation completes
   */
  static review(
    id: Required<ICampaignSubmissionModel>['id'],
    payload: {
      status: ECampaignSubmissionStatus
    }
  ): TAxiosResponseData<void> {
    return axiosHiringApi.put(`${this._prefix}/${id}/review`, payload)
  }

  static multipleReview(
    payload: {
      ids: Required<ICampaignSubmissionModel>['id'][]
      status: ECampaignSubmissionStatus
    }
  ): TAxiosResponseData<void> {
    return axiosHiringApi.put(`${this._prefix}/review-multiple`, payload)
  }

  /**
   * Reject an applicant and move them to the Rejected tab
   * @param id Submission ID
   * @param payload Rejection data
   * @returns Promise that resolves when the operation completes
   */
  static pass(
    id: Required<ICampaignSubmissionModel>['id'],
    payload: {
      rejectionReason?: string
    }
  ): TAxiosResponseData<void> {
    return axiosHiringApi.put(`${this._prefix}/${id}/pass`, payload)
  }

  static multiplePass(
    payload: {
      ids: Required<ICampaignSubmissionModel>['id'][]
      rejectionReason?: string
    }
  ): TAxiosResponseData<void> {
    return axiosHiringApi.put(`${this._prefix}/pass-multiple`, payload)
  }

  /**
   * Mark an applicant as hired
   * @param id Submission ID
   * @returns Promise that resolves when the operation completes
   */
  static markAsHired(
    id: Required<ICampaignSubmissionModel>['id']
  ): TAxiosResponseData<void> {
    return axiosHiringApi.put(`${this._prefix}/${id}/hire`, {})
  }
}
